import { Link, useLocation } from 'react-router-dom';
import common from '@/mocks/zh/common';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items?: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const getDefaultItems = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const result: BreadcrumbItem[] = [
      { label: common.breadcrumb.home, path: '/' },
    ];

    if (pathSegments.length === 0) return result;

    const pathMap: Record<string, string> = {
      categories: common.breadcrumb.categories,
      articles: common.breadcrumb.articles,
      about: common.breadcrumb.about,
    };

    pathSegments.forEach((segment, index) => {
      const path = '/' + pathSegments.slice(0, index + 1).join('/');
      const label = pathMap[segment] || segment;
      result.push({ label, path });
    });

    return result;
  };

  const breadcrumbItems = items || getDefaultItems();

  return (
    <nav aria-label="Breadcrumb" className="w-full bg-background-50 border-b border-background-200/50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center gap-1.5 text-sm flex-wrap">
          {breadcrumbItems.map((item, index) => {
            const isLast = index === breadcrumbItems.length - 1;
            return (
              <li key={index} className="flex items-center gap-1.5">
                {index > 0 && (
                  <i className="ri-arrow-right-s-line text-foreground-300 text-xs" />
                )}
                {isLast || !item.path ? (
                  <span className="text-foreground-600 font-medium">{item.label}</span>
                ) : (
                  <Link
                    to={item.path}
                    className="text-foreground-400 hover:text-primary-600 transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
}